/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Component imports */

/* Style imports */
import './styles.css'
/*** End Imports ***/

const LoginHeader = props => {

    return(
        <div className="lg-mdl-hdr-container">
            {
                props.showHeaderLftBtn ?
                <div className="lg-mdl-hdr-icon-cntnr left-btn" onClick={props.leftBtnClickListener}>
                    <i className="material-icons">arrow_back</i>
                </div>
                : 
                null
            }
            <div className="lg-mdl-hdr-lbl">
                {props.title}
            </div>
            {
                props.showHeaderRgtBtn ?
                <div className="lg-mdl-hdr-icon-cntnr" onClick={props.rightBtnClickListener}>
                    <i className="material-icons">close</i>
                </div>
                :
                null
            }

        </div>
    );
};

LoginHeader.propTypes = {
    showHeaderLftBtn : PropTypes.bool,
    showHeaderRgtBtn : PropTypes.bool,
    leftBtnClickListener : PropTypes.func,
    rightBtnClickListener : PropTypes.func,
    leftBtnMaterialIcon : PropTypes.string,
    rightBtnMaterialIcon : PropTypes.string,
    title : PropTypes.string.isRequired,
};
LoginHeader.defaultProps = {
    showHeaderLftBtn : false,
    showHeaderRgtBtn : false
};

export default LoginHeader;


// WEBPACK FOOTER //
// ./src/components/core/LoginHeader/LoginHeader.js


// WEBPACK FOOTER //
// ./src/components/core/LoginHeader/LoginHeader.js